export default __webpack_public_path__ + "static/media/sliderFlip_noThemeSelected.a305bde8.svg";